import { render, staticRenderFns } from "./PatientEmergencyInvoice.vue?vue&type=template&id=1e88fdcd&scoped=true"
import script from "./PatientEmergencyInvoice.vue?vue&type=script&lang=js"
export * from "./PatientEmergencyInvoice.vue?vue&type=script&lang=js"
import style0 from "./PatientEmergencyInvoice.vue?vue&type=style&index=0&id=1e88fdcd&prod&scoped=true&lang=css"
import style1 from "./PatientEmergencyInvoice.vue?vue&type=style&index=1&id=1e88fdcd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e88fdcd",
  null
  
)

export default component.exports